import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/home.vue'),
    redirect:"/index",
    children:[
      {
        path: '/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '首页'
        },
      },
      {
        path: '/news',
        component: () => import('@/views/news.vue'),
        meta: {
          title: '新闻资讯'
        },
      },
      {
        path: '/newsDetail',
        component: () => import('@/views/newsDetail.vue'),
        meta: {
          title: '新闻详情'
        },
      },
      {
        path: '/about',
        component: () => import('@/views/about.vue'),
        meta: {
          title: '关于我们'
        },
      },
      {
        path: '/detail',
        component: () => import('@/views/detail.vue'),
        meta: {
          title: '案例详情'
        },
      },
    ]
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next)=>{
  document.title = to.meta.title
  next()
  // if(to.path === '/login'){
  //   next()
  // }else{
  //   const token = sessionStorage.getItem('token')
  //   if (!token) {
  //     router.push("/login")
  //   }else{
  //     next()
  //   }
  // }
})
export default router
